import { FormattedMessage } from 'react-intl'
import { getRouteApi } from '@tanstack/react-router'

import { Alert } from '@gto/ui/alert'
import { IconGtoWizardLogoSigned } from '@gto/ui/assets'
import { Button } from '@gto/ui/button'
import { Paper } from '@gto/ui/paper'
import { Typography } from '@gto/ui/typography'

import { buildOAuthRedirectUrl } from '@/utils/oauth'

const routeApi = getRouteApi('/_auth/login/oauth/')

// The loader either throws a redirect (success / already-processed code) or
// resolves with `{ status: 'error', message }` — so this component only ever
// renders the error UI. No success branch.
export const OauthCallback = () => {
  const data = routeApi.useLoaderData()

  const handleRetry = () => {
    void buildOAuthRedirectUrl().then((url) => {
      window.location.href = url
    })
  }

  return (
    <div className="flex h-dvh items-center justify-center overflow-hidden bg-gradient-primary-vertical p-6">
      <Paper
        className="w-full max-w-[420px] rounded-lg p-8 sm:p-6"
        variant="outlined"
      >
        <div className="flex flex-col gap-8">
          <IconGtoWizardLogoSigned style={{ height: 24, width: 'auto' }} />

          <div className="flex flex-col gap-2">
            <Typography
              className="font-semibold"
              color="text.primary"
              variant="h5"
            >
              <FormattedMessage id="auth.oauth.error.title" />
            </Typography>
            <Typography
              color="text.secondary"
              variant="body2"
            >
              <FormattedMessage id="auth.oauth.error.description" />
            </Typography>
          </div>

          {data.message.length > 0 && <Alert severity="error">{data.message}</Alert>}

          <Button
            fullWidth
            color="primary"
            variant="contained"
            onClick={handleRetry}
          >
            <FormattedMessage id="auth.oauth.error.retry" />
          </Button>
        </div>
      </Paper>
    </div>
  )
}
